import SocialMedia from './social-media-controller'

export default SocialMedia
